<template>
    <div>
        <Header></Header>
        <v-row class="pa-12">
            <v-col md="3">
                <v-card class="mb-8 pa-2 pa-md-6 mr-8" style="height: fit-content" elevation="5" outlined name="index">
                    <v-card-title class="mb-3">
                        <span class="headline">Rechercher</span>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-row>
                                <!-- Prenom -->
                                <v-text-field v-model="filters.firstName"
                                              label="Prénom"
                                              required></v-text-field>
                            </v-row>
                            <v-row>
                                <!-- Nom -->
                                <v-text-field v-model="filters.lastName"
                                              label="Nom"
                                              required></v-text-field>
                            </v-row>
                            <v-row>
                                <!-- Ville -->
                                <v-text-field v-model="filters.ville"
                                              label="Ville"
                                              required></v-text-field>
                            </v-row>
                            <v-row>
                                <!-- Région -->
                                <v-autocomplete :item-text="itemText"
                                                :item-value="itemValue"
                                                :items="listeRegionAdministrative"
                                                v-model="filters.region"
                                                label="Région"
                                                clear-icon="mdi-close-circle"
                                                clearable
                                                multiple></v-autocomplete>
                            </v-row>
                            <v-row>
                                <!-- Pratique professionnel -->
                                <v-autocomplete :item-text="itemText"
                                                :item-value="itemValue"
                                                :items="listeDesginationsContextePratique"
                                                v-model="filters.pratiqueProf"
                                                label="Pratique professionnelle"
                                                clear-icon="mdi-close-circle"
                                                clearable
                                                multiple></v-autocomplete>
                            </v-row>
                            <v-row>
                                <!-- Champs d’exercice -->
                                <v-autocomplete :item-text="itemText"
                                                :item-value="itemValue"
                                                :items="listeDesignationsContextChamps"
                                                v-model="filters.champExer"
                                                label="Champs d’exercice"
                                                clear-icon="mdi-close-circle"
                                                clearable
                                                multiple></v-autocomplete>
                            </v-row>
                            <v-row>
                                <!-- Expertise particulière-->
                                <v-autocomplete :item-text="itemText"
                                                :item-value="itemValue"
                                                :items="listeDesignationsContexteExpertise"
                                                v-model="filters.expertise"
                                                label="Expertise particulière"
                                                clear-icon="mdi-close-circle"
                                                clearable
                                                multiple></v-autocomplete>
                            </v-row>
                            <v-row>
                                <!-- Type d’organisation-->
                                <v-autocomplete :item-text="itemText"
                                                :item-value="itemValue"
                                                :items="listeTypesOrganisation"
                                                v-model="filters.typeOrganisation"
                                                label="Type d’organisation"
                                                clear-icon="mdi-close-circle"
                                                clearable
                                                multiple></v-autocomplete>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="search">Rechercher</v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
            <v-col md="9">
                <v-card class="mb-8 pa-2 pa-md-6" elevation="5" outlined name="index">
                    <ExpandableDataTable :loading="loading"
                                         :title="tableTitle"
                                         :headers="membresHeaders"
                                         :data="listeMembres"
                                         :itemsPerPage="itemsPerPage"
                                         :singleExpand="singleExpand"
                                         :totalPages="totalData"
                                         @refreshOptions="refreshOptions">
                    </ExpandableDataTable>
                </v-card>
            </v-col>
        </v-row>
        <Footer></Footer>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import Header from "../components/Header"
    import Footer from "../components/Footer"
    import ExpandableDataTable from "../components/common/ExpandableDataTable"
    import SearchList from "../components/common/SearchList"

    export default {
        components: {
            Header,
            Footer,
            ExpandableDataTable,
            SearchList
        },
        data() {
            return {
                options: {},
                filters: {
                    firstName: "",
                    lastName: "",
                    ville: "",
                    region: "",
                    pratiqueProf: "",
                    champExer: "",
                    expertise: "",
                    typeOrganisation: ""
                },
                singleExpand: true,
                itemsPerPage: 20,
                filterLoading: true,
                loading: false,
                tableTitle: "Tableau des membres",
                membresHeaders: [
                    {
                        text: 'Prénom',
                        align: 'start',
                        sortable: false,
                        value: 'firstName',
                    },
                    { text: 'Nom de famille', value: 'lastName' },
                    { text: 'Organisation', value: 'cartesDeVisite[0].pm.label' },
                    { text: 'Ville', value: 'cartesDeVisite[0].ville' }
                ]
            }
        },
        computed: {
            ...mapGetters('TableauDesMembres', {
                listeMembres: 'GetterMembres',
                totalData: 'GetterTotal'
            }),
            ...mapGetters('Catalogue', {
                listeDesignations: 'GET_DESIGNATION',
                listeRegionAdministrative: 'GET_REGIONADMINISTRATIVE',
                listeTypesOrganisation: 'GET_TYPEORGANISATION',
                listeDesignationsContextChamps: 'GET_DESIGNATIONCONTEXTCHAMP',
                listeDesignationsContexteExpertise: 'GET_DESIGNATIONCONTEXTEXPERTISE',
                listeDesginationsContextePratique: 'GET_DESIGNATIONCONTEXTPRATIQUE'
            }),
            designationsFilters: function () {
                return this.listeDesignations
            }
        },
        mounted() {
            this.initialize()
        },
        methods: {
            ...mapActions({
                LoadMembres: 'TableauDesMembres/ChargeMembres',
                LoadCatalogue: 'Catalogue/getCatalogue',
                LoadCatalogueWithParentContext: 'Catalogue/getCatalogueWithParentContext'
            }),
            async initialize() {
                this.loading = true;

                //await this.LoadMembres();
                await this.LoadFilters();
                this.search();

                this.loading = false;
            },
            async LoadFilters() {

                // Chargement des catalogues utilise pour le filtrage des membres

                // Region
                await this.LoadCatalogue(1102)

                // Designation Context Champs Exercices
                await this.LoadCatalogueWithParentContext({ descid: 1204, parentdescid: 7823})

                // Designation Context Expertises particulieres
                await this.LoadCatalogueWithParentContext({ descid: 1204, parentdescid: 7824 })

                // Designation Context Pratique Pro
                await this.LoadCatalogueWithParentContext({ descid: 1204, parentdescid: 7822})

                // Type d'organisation
                await this.LoadCatalogue(314)
            },
            search() {
                this.loading = true;

                let params = {
                    PageSize: this.itemsPerPage,
                    PageNumber: this.options.page
                }

                this.LoadMembres({ Parameters: params, SearchCriterias: this.filters }).then(data => {
                    this.loading = false;
                })
            },
            refreshOptions(options) {
                this.options = options
                this.search();
            },
            itemText: (item) => item.lang00,
            itemValue: (item) => item.lang00,
        }
    }
</script>

<style>
    /* Scrollbar CSS */
    /* Track */
    ::-webkit-scrollbar-track {
        background: #e6e6e6;
        border-left: 1px solid #dadada;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: #b0b0b0;
        border: solid 3px #e6e6e6;
        border-radius: 7px;
    }

        /* Handle on hover */
        ::-webkit-scrollbar-thumb:hover {
            background: black;
        }

    ::-webkit-scrollbar {
        width: 15px;
    }
</style>